import React from 'react';
import { Crown, ArrowRight } from '@phosphor-icons/react';

/**
 * UpgradeButton - Consistent upgrade CTA across the app
 * Variants: 'compact', 'banner', 'inline'
 */
const UpgradeButton = ({ 
  onClick, 
  variant = 'compact',
  currentPlan = 'free',
  className = '' 
}) => {
  // Don't show upgrade for paid plans
  if (currentPlan && !['free', 'trial'].includes(currentPlan.toLowerCase())) {
    return null;
  }

  if (variant === 'banner') {
    return (
      <button
        onClick={onClick}
        data-testid="upgrade-banner-btn"
        className={`w-full p-4 bg-gradient-to-r from-amber-500/20 to-orange-500/20 border border-amber-500/30 rounded-xl hover:border-amber-500/50 transition-all ${className}`}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center">
              <Crown size={20} className="text-white" weight="fill" />
            </div>
            <div className="text-left">
              <p className="text-white font-semibold">Unlock All Features</p>
              <p className="text-slate-400 text-sm">Get unlimited content, offers, and more</p>
            </div>
          </div>
          <div className="flex items-center space-x-2 text-amber-400">
            <span className="text-sm font-medium">Upgrade</span>
            <ArrowRight size={16} />
          </div>
        </div>
      </button>
    );
  }

  if (variant === 'inline') {
    return (
      <button
        onClick={onClick}
        data-testid="upgrade-inline-btn"
        className={`flex items-center space-x-1.5 px-3 py-1.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity ${className}`}
      >
        <Crown size={14} weight="fill" />
        <span>Upgrade</span>
      </button>
    );
  }

  // Compact (default)
  return (
    <button
      onClick={onClick}
      data-testid="upgrade-compact-btn"
      className={`flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-medium rounded-lg transition-all ${className}`}
    >
      <Crown size={16} weight="fill" />
      <span>Upgrade</span>
    </button>
  );
};

export default UpgradeButton;
